import { lazy } from "react";
import { IRoute } from "./types";

const NotFound = lazy(() => import("pages/exceptions/NotFound"));

const Advertisements = lazy(() => import("pages/dashboard/advertisement"));
const Promos = lazy(() => import("pages/dashboard/promo"));
const FeedbackRefs = lazy(() => import("pages/dashboard/machine/feedback_ref"));
const Feedbacks = lazy(() => import("pages/dashboard/machine/feedback"));

const dashboardRoutes: IRoute[] = [
  {
    key: "/ads",
    path: "ads",
    component: <Advertisements />,
  },
  {
    key: "/promo",
    path: "promo",
    component: <Promos />,
  },
  {
    key: "/machine/feedback_ref",
    path: "machine/feedback_ref",
    component: <FeedbackRefs />,
  },
  {
    key: "/machine/feedback",
    path: "machine/feedback",
    component: <Feedbacks />,
  },
  {
    key: "not_found",
    path: "*",
    component: <NotFound />,
  },
];
export default dashboardRoutes;
